<template>
  <div class="layout--full-page auth-wrapper auth-v1 px-2 bg-img">
    <div class="auth-inner py-2" style="max-width: 60%;">

      <!-- Login v1 -->
      <div>
        <b-card class="mb-0">
          <div class="">
            <div style="text-align: center;" class="mb-2">
                <img class="logo d-none d-lg-inline" src="@/assets/images/logo/logo-signathor.webp" alt="Logo">
                <img class="logo-sm d-lg-none" src="@/assets/images/logo/signathor_transparent.webp" alt="Logo">
            </div>
            <b-row
              class="no-gutter d-flex align-items-center"
            >
              <b-col
                class="d-none d-lg-block"
                lg="6"
              >
                <img src="@/assets/images/pages/register.webp" alt="login" style="margin: 0px 5px">
              </b-col>
              <b-col
                class=""
                xs="12"
                sm="12"
                md="12"
                lg="6"
              >
                <div class="vx-card__title">
                  <h4 class="">Registrar</h4>
                  <p>Complete los campos para crear una nueva cuenta.</p>
                </div>
                <register-jwt></register-jwt>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </div>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import RegisterJwt from './RegisterJWT.vue'

export default {
    data(){
        return{
            allowRegister: false
        }
    },
    components: {
        RegisterJwt
    },
    created(){
        if(this.$cookie.get('usuario') != null){
            this.$router.push("/")
        }else{
            this.allowRegister = true;
        }
  }
}
</script>

<style lang="scss">
    .register-tabs-container {
        min-height: 490px;

        .con-tab {
            padding-bottom: 23px;
        }
    }
</style>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

    .logo{
        height: 60px;
        width: 18rem;
    }
    .logo-sm{
        height: 100px;
    }
</style>
